import { Suspense, useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { RouteLoadingState } from "./RouteLoadingState";
import { appRoutes } from "./router";
import { AuthProvider, useAuth } from "../features/auth/auth";
import { AnalyticsProvider, useAnalytics } from "../features/analytics/analytics";

const router = createBrowserRouter(appRoutes, {
  basename: import.meta.env.BASE_URL.replace(/\/$/, "") || "/",
});

export function App() {
  return (
    <AnalyticsProvider>
      <AuthProvider>
        <AnalyticsIdentity />
        <Suspense fallback={<RouteLoadingState />}>
          <RouterProvider router={router} />
        </Suspense>
      </AuthProvider>
    </AnalyticsProvider>
  );
}

function AnalyticsIdentity() {
  const { account } = useAuth();
  const analytics = useAnalytics();
  useEffect(() => { if (account?.id) analytics.identify(account.id); }, [account?.id, analytics]);
  return null;
}
